module.exports = __webpack_public_path__ + "static/sport/form-bg.f806cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/form/form-bg.png
// module id = lYJk
// module chunks = 0